import { Spinner } from "@phosphor-icons/react";

export default function ProjectLoadingScreen({ label = "Loading project…" }) {
  return (
    <div className="min-h-screen w-full bg-slate-50 flex items-center justify-center" data-testid="project-loading-screen">
      <div className="flex items-center gap-3 text-slate-500 text-sm font-mono-ibm">
        <Spinner size={18} weight="bold" className="animate-spin" />
        {label}
      </div>
    </div>
  );
}
